import React from 'react';

import PlusIcon from '../../../../../assets/svgComponents/PlusIcon';

import './animatedCloseButtonComponent.css';

const AnimatedCloseButtonComponent = ({onClick = () => {}}) => {
  return (
    <div className="et-v2-animated-close-btn-container" onClick={onClick}>
      <PlusIcon />
    </div>
  );
};

export default AnimatedCloseButtonComponent;
